import React from 'react'
import PropTypes from 'prop-types'
import {
  Alert, Button, Modal, TextArea
} from '@sainsburys-tech/fable'
import ThanksMessage from './ThanksMessage'
import api from '../../utils/api'

const satisfactionLevels = [
  [1, '😰', 'nervous face', 'Very dissatisfied'],
  [2, '😩', 'veary face', 'Dissatisfied'],
  [3, '😐', 'neutral face', 'Neutral'],
  [4, '😄', 'smiley face', 'Satisfied'],
  [5, '😍', 'heart face', 'Very satisfied'],
]

class FeedbackCard extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      formSubmitted: false,
      isOpen: true,
      showError: false,
      disabledButton: false,
      feedback: { rating: '', comment: '' }
    }
  }

	submitForm = async () => {
	  const { appId, email } = this.props
	  api.submitFeedback(appId, this.state.feedback, email)
	    .then(() => {
	      this.setState({ formSubmitted: true })
	    })
	}

	handleClose = () => {
	  const { appId, email } = this.props
	  this.setState({ disabledButton: true })
	  api.submitFeedback(appId, { rating: 0, comment: '' }, email)
	    .finally(() => {
	      this.setState({ isOpen: false, disabledButton: false })
	    })
	}

	setRating = (ratingLevel) => {
	  this.setState({ feedback: { ...this.state.feedback, rating: ratingLevel } })
	  this.setState({ showError: false })
	}

	handleChange = (value) => {
	  this.setState({ feedback: { ...this.state.feedback, comment: value } })
	}

	handleValidation = () => {
	  if (this.state.feedback.rating === '') {
	    this.setState({ showError: true })
	  } else {
	    this.setState({ disabledButton: true })
	    this.submitForm()
	  }
	}

	render() {
	  const {
	    formSubmitted, isOpen, showError, disabledButton
	  } = this.state
	  const { headerText, bodyText } = this.props

	  if (!isOpen) {
	    return null
	  }

	  if (formSubmitted) {
	    return <ThanksMessage />
	  }

	  return (
  <Modal
    header={{
				  label: headerText,
				  isDismissible: true,
    }}
    isOpen={isOpen}
    onClose={this.handleClose}
    hasClickawayClose={false}
    renderFooter={(
      <div className="dsib-feedbackModal__footer">
        <Button
          type="button"
          variant="primary"
          isFullWidth
          onClick={this.handleValidation}
          disabled={disabledButton}
        >
          Submit
        </Button>
        <Button
          type="button"
          variant="tertiary"
          isFullWidth
          onClick={this.handleClose}
          disabled={disabledButton}
        >
          Maybe Later
        </Button>
      </div>
				)}
  >
    <div className="dsib-feedbackModal__body">
      <p className="dsib-feedbackModal__intro">{bodyText}</p>

      <h3 className="dsib-feedbackModal__question">How satisfied are you with this tool?</h3>
      <div className="dsib-feedbackModal__ratings">
        {satisfactionLevels.map((satisfactionLevel) => {
						  const level = satisfactionLevel[0]
						  const emoji = satisfactionLevel[1]
						  const label = satisfactionLevel[3]
						  const inputId = `feedback-rating-${level}`

						  return (
  <div className="radio-toolbar dsib-feedbackModal__rating" key={`satlevel-${level}`}>
    <div className="feedback-satisfactionLevel">
      <input
        type="radio"
        id={inputId}
        name="feedbackRating"
        value={level}
        checked={this.state.feedback.rating === level}
        onChange={() => this.setRating(level)}
        disabled={disabledButton}
      />
      <label htmlFor={inputId}>
        <span aria-label={label} role="img" className="feedback-emojiImage">
          {emoji}
        </span>
        <div className="feedback-emojiButtonName">{label}</div>
      </label>
    </div>
  </div>
						  )
        })}
      </div>

      {showError && (
      <div className="dsib-feedbackModal__error">
        <Alert status="error" isOpen message="Please rate the app before submitting" />
      </div>
      )}

      <h3 className="dsib-feedbackModal__question">How could we improve it? (optional)</h3>
      <div className="dsib-feedbackModal__textArea">
        <TextArea
          label="Additional comments"
          hasHiddenLabel
          name="feedbackComment"
          value={this.state.feedback.comment}
          textAreaProps={{
							  rows: 6,
							  maxLength: 250,
							  placeholder: 'Add any additional comments here ...',
          }}
          onChange={value => this.handleChange(value)}
        />
      </div>
    </div>
  </Modal>
	  )
	}
}

FeedbackCard.propTypes = {
  appId: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  bodyText: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired
}

export default FeedbackCard
